function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

// class DeferredMedia extends HTMLElement {
//   constructor() {
//     super();
//     const poster = this.querySelector('[id^="Deferred-Poster-"]');
//     if (!poster) return;
//     poster.addEventListener('click', this.loadContent.bind(this));
//   }

//   loadContent() {
//     window.pauseAllMedia();
//     if (!this.getAttribute('loaded')) {
//       const content = document.createElement('div');
//       content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

//       this.setAttribute('loaded', true);
//       this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
//     }
//   }
// }

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) { 
    this.syncVariantInputs(event) 
    this.productLoaderStart();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateItemInventory();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    
    let newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    ) || document.querySelector(
      `[data-media-id$="-${this.currentVariant.featured_media.id}"]`
    );
    
    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`) || document.querySelector(`.product-media-modal__content`) 
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const image = document.querySelector('.atc-product-media img')
      
    if(image) {
      const imagePath = newMedia.querySelector('img').src
      
      if(imagePath){
        image.src = imagePath
      }
    }

    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    
    /********************************************/
    let selectedIndex = null;
    newMedia.classList.forEach(className => {
      if (className.startsWith("index-")){
        selectedIndex = className;
      }
    });
    const mainCarousel = document.querySelector(`.product-carousel-desktop .product-carousel-image`);
    const mobileCarousel = document.querySelector(`.product-carousel-mobile .product-carousel-image`);
    const currentVariantSlide = document.querySelector(`.product-carousel-desktop .product-carousel-image .${selectedIndex}`);
    const currentVariantMobileSlide = document.querySelector(`.product-carousel-mobile .product-carousel-image .${selectedIndex}`);
    mainCarousel.prepend(currentVariantSlide);
    mobileCarousel.prepend(currentVariantMobileSlide);
    /********************************************/
    
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      //parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
      //window.scrollTo({top: 0, behavior: 'smooth'});
      
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  
  updateItemInventory() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
    var updated_variant_id = this.currentVariant.id;
    //console.log('name="id" updated: ' + updated_variant_id);
    var parser = new DOMParser();
    var get_script = parser.parseFromString(document.getElementById('product_variants_inventory').textContent, 'text/html');
    //console.log('get_script: ' , get_script);
    var get_inventory_data = get_script.querySelector('option[value="'+ updated_variant_id +'"]').getAttribute('data-inventory');
    var add_to_cart_button = document.querySelector('.product-form__submit');
    //console.log('get_inventory_data: ' , get_inventory_data);
    
    let inventory_container = document.querySelector('.but_now_heading_container');

    if(get_inventory_data > 0 && get_inventory_data < 10){
      inventory_container.querySelector('.inventory_data .inventory_count').innerHTML = get_inventory_data;
      inventory_container.classList.add('inventory_active')
    }
    else{
      inventory_container.classList.remove('inventory_active')
    }

    if(document.querySelector('[name="outlet_sale-'+updated_variant_id+'"]')) {
      document.querySelector('.outlet-sale-disclaimer span').style.display = 'block';
    } else {
      document.querySelector('.outlet-sale-disclaimer span').style.display = 'none';
    }

  }

  syncVariantInputs(event) {
    const target = event.target;
  
    if (target.type !== "radio") return;
  
    const name = target.name;
    const value = target.value;
  
    document.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((input) => {
      if (input !== target && input.value === value && !input.checked) {
        input.checked = true;
      }
    });
  }
  

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, .sticky-atc-bar form`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        const product_form = document.querySelector('product-form');

        const id2 = `price-${this.dataset.section}-2`;
        const destination2 = document.getElementById(id2);
        const source2 = html.getElementById(id2);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source2 && destination2) destination2.innerHTML = source2.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        const price2 = document.getElementById(`price-${this.dataset.section}-2`);

        if (price) price.classList.remove('visibility-hidden');
        if (price2) price2.classList.remove('visibility-hidden');

        const coming_soon_true = document.querySelector(`.coming_soon-true`);
        const coming_soon_badge = document.querySelector(`.coming_soon-true .price:not(.price--sold-out)`);
        //console.log('coming_soon_true: ' + coming_soon_true);
        //console.log('coming_soon_badge: ' + coming_soon_badge);
        if(coming_soon_badge == null && coming_soon_true != null) {
          this.toggleAddButton(!this.currentVariant.available, 'Coming Soon');
        }else{
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        if(!this.currentVariant.available){
          product_form.classList.add('sold-out');
        }
        else{
          product_form.classList.remove('sold-out');
        }

        this.productLoaderStop();

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productForms = document.querySelectorAll(`.sticky-atc-bar form`);
    
    const allForms = productForm ? [productForm, ...productForms] : [...productForms];

    if (allForms.length === 0) return;

    allForms.forEach(item => {
        const addButton = item.querySelector('[name="add"]');
        const addButtonText = item.querySelector('[name="add"] > span');

        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text && addButtonText) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
        }
    });

    if (!modifyClass) return;
}

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  productLoaderStart() {
    //console.log('astral_loader starts');
    document.querySelector('.product_image_banner_info').classList.add('astral_loader');
    setTimeout(function(){
      //document.querySelector('.product_image_banner_info').classList.remove('astral_loader');
    }, 3000);//wait 3 seconds
  }

  productLoaderStop() {
    //console.log('astral_loader stops');
    document.querySelector('.product_image_banner_info').classList.remove('astral_loader');

  }

}

customElements.define('variant-selects', VariantSelects);

function product_variant_availability_checker(element){  
  var variantradios = document.querySelector('variant-radios'); // check if variant-radios exist on pdp
  if(typeof(variantradios) != 'undefined' && variantradios != null){
      
      var product_variants = JSON.parse(document.getElementById('product_variants').textContent);
      
      if(document.querySelector('variant-radios .Color-variant-switcher')){
        var variant_color_checked = document.querySelector('variant-radios .Color-variant-switcher input:checked').value;
      }

      if(element){
        var variant_color_checked = element.querySelector('.Color-variant-switcher input:checked').value;
      }
      //console.log('variant_color_checked: ', variant_color_checked);

      //disabling all size variants by default
      var variant_size_inputs = document.querySelectorAll('variant-radios .Size-variant-switcher input');
      
      
      variant_size_inputs.forEach(function (size_variant, index) {
        //size_variant.setAttribute('disabled','disabled');
        size_variant.classList.add('disabled');
      });

      //disabling all color variants by default
      var variant_color_inputs = document.querySelectorAll('variant-radios .Color-variant-switcher input');
      
      
      variant_color_inputs.forEach(function (color_variant, index) {
        //color_variant.setAttribute('disabled','disabled');
        color_variant.classList.add('disabled');
      });

      // checking all size variants of all color variant and then enable available variants
      var variant_color_input_all = document.querySelectorAll('variant-radios .Color-variant-switcher input');

      
      variant_color_input_all.forEach(function (color_input, index) {
        input_value = color_input.value;
        
        product_variants.forEach(function (product_variant, index) {
          if(product_variant.option1 == input_value && product_variant.available == true){
            //console.log('product_variant.available: '+ product_variant.available + ' input_value: '+ input_value);
            var variant_color_input = document.querySelectorAll('variant-radios .Color-variant-switcher input[value="'+input_value+'"]');
            //variant_color_input.removeAttribute('disabled','disabled');
            // variant_color_input.classList.remove('disabled');
            variant_color_input.forEach(item => {
              item.classList.remove('disabled');
            })
          }
        });
      });

      // checking all size variants of checked color variant
      available_variants_count = 0;
      product_variants.forEach(function (product_variant, index) {  
        if(product_variant.option1 == variant_color_checked && product_variant.available == true){
          available_variants_count++;
          get_size = product_variant.option2;
          var variant_size_inputs = document.querySelectorAll('variant-radios .Size-variant-switcher input[value="'+get_size+'"]');
          var variant_style_inputs = document.querySelectorAll('variant-radios .Style-variant-switcher input[value="'+get_size+'"]');
          var variant_material_inputs = document.querySelectorAll('variant-radios .Material-variant-switcher input[value="'+get_size+'"]');

          //variant_size_inputs.removeAttribute('disabled','disabled');
          if(variant_style_inputs.length > 0){
            // variant_style_inputs.classList.remove('disabled');
            variant_style_inputs.forEach(item => {
              item.classList.remove('disabled');
            })
          }
          else if(variant_material_inputs.length > 0){
            // variant_material_inputs.classList.remove('disabled');
            variant_material_inputs.forEach(item => {
              item.classList.remove('disabled');
            })
          }
          else if(variant_size_inputs.length > 0){
            // variant_size_inputs.classList.remove('disabled');
            variant_size_inputs.forEach(item => {
              item.classList.remove('disabled');
            })
          }
        }
      });


    } 
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  /* content change as per variant selected start */
  updateOptions() {

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    var variantContent = document.querySelectorAll('.variant--content');
    variantContent[0].classList = 'page-width variant--content';
    variantContent[0].classList.add("Content--"+this.options[0].split(" ").join("-").toLowerCase());
    
    var selectedColorImages = document.querySelectorAll('.product__media-list');
    var newClasses = "selectedColor--"+this.options[0].split(" ").join("-").toLowerCase();

    product_variant_availability_checker(this);

    // More Dynamic
    
    selectedColorImages.forEach(el => {
      var classList = el.classList;
      classList.forEach(className => {
        if (className.startsWith("selectedColor--")){
          classList.remove(className);
        }

        var strnewClasses = newClasses.replaceAll('/', '-').trim()
        el.classList.add(strnewClasses);
        //console.log(strnewClasses);
      });
    });
  }

/* content change as per variant selected end */
}
customElements.define('variant-radios', VariantRadios);

function addSwatchesEventListener() {
  var swatches = document.querySelectorAll('.astral-product-card-variant-img');
  swatches.forEach(el => el.addEventListener('click', event => {
    var card_img = el.closest('.astral-product-card').querySelector('.astral-product-card-img');

    var link = el.closest('.astral-product-card').querySelector('a');
    // Copy over attributes
    card_img.src = el.src;
    card_img.srcset = el.srcset;
    // Create link to point to the correct variant (variant id is stored in the img if of the swatch image)
    link.href = link.href.split('?')[0] + '?variant=' + el.id;
    
    var siblings = el.closest('.astral-product-card').querySelectorAll('.astral-product-card-variant-img');
    siblings.forEach(elem => {
      if(el == elem) { 
        elem.classList.add('active')
      } else {
        elem.classList.remove('active')
      }
    });
  }));

  var product_variations_btn = document.querySelectorAll('.product-variations:not(.show)');
  product_variations_btn.forEach(function (el) {
      el.addEventListener('click', function () {
          /* remove class from all */
          product_variations_btn.forEach(function (el) {
            var card_content = el.closest('.astral-product-card-content');
            card_content.classList.remove('show-variants');
          });

          /* add class to current */
          var card_content = el.closest('.astral-product-card-content');
          card_content.classList.add('show-variants');
          el.classList.add('show');

      });
  });
}

addSwatchesEventListener(); // for collection page, filter page etc
product_variant_availability_checker(); // for pdp page

(function(document, history, location) {
  var HISTORY_SUPPORT = !!(history && history.pushState);

  var anchorScrolls = {
    ANCHOR_REGEX: /^#[^ ]+$/,
    OFFSET_HEIGHT_PX: 85,

    /**
     * Establish events, and fix initial scroll position if a hash is provided.
     */
    init: function() {
      this.scrollToCurrent();
      window.addEventListener('hashchange', this.scrollToCurrent.bind(this));
      document.body.addEventListener('click', this.delegateAnchors.bind(this));
    },

    /**
     * Return the offset amount to deduct from the normal scroll position.
     * Modify as appropriate to allow for dynamic calculations
     */
    getFixedOffset: function() {
      return this.OFFSET_HEIGHT_PX;
    },

    /**
     * If the provided href is an anchor which resolves to an element on the
     * page, scroll to it.
     * @param  {String} href
     * @return {Boolean} - Was the href an anchor.
     */
    scrollIfAnchor: function(href, pushToHistory) {
      var match, rect, anchorOffset;

      if(!this.ANCHOR_REGEX.test(href)) {
        return false;
      }

      match = document.getElementById(href.slice(1));

      if(match) {
        rect = match.getBoundingClientRect();
        anchorOffset = window.pageYOffset + rect.top - this.getFixedOffset();
        //window.scrollTo(window.pageXOffset, anchorOffset);

        // Add the state to history as-per normal anchor links
        if(HISTORY_SUPPORT && pushToHistory) {
          history.pushState({}, document.title, location.pathname + href);
        }
      }

      return !!match;
    },

    /**
     * Attempt to scroll to the current location's hash.
     */
    scrollToCurrent: function() {
      //.scrollIfAnchor(window.location.hash);
    },

    /**
     * If the click event's target was an anchor, fix the scroll position.
     */
    delegateAnchors: function(e) {
      var elem = e.target;

      if(
        elem.nodeName === 'A' &&
        this.scrollIfAnchor(elem.getAttribute('href'), true)
      ) {
          //console.log(window.location.pathname );
          //e.preventDefault();
      }
    }
  };

  window.addEventListener(
    'DOMContentLoaded', anchorScrolls.init.bind(anchorScrolls)
  );
})(window.document, window.history, window.location);

function jump_to_review_tab(){
  product_reviews_tabs = document.querySelector('#product_reviews_tabs');
  product_reviews_tabs_details = document.querySelector('#product_reviews_tabs details');
  features_tab = document.querySelector('.product__accordion details');
  features_tab.removeAttribute('open');
  product_reviews_tabs.scrollIntoView();
  product_reviews_tabs_details.setAttribute('open', '');
}

review_counts = document.getElementById('review_counts');

if(review_counts){
  review_counts.addEventListener('click', event => {
    event.preventDefault();
    jump_to_review_tab();
    //console.log(' review_counts ');
  });
}



const klavioPopupLinks = document.querySelectorAll('.klaviyo_form_trigger');

klavioPopupLinks.forEach(el => el.addEventListener('click', event => {
  var _klOnsite = window._klOnsite || []; _klOnsite.push(['openForm', event.target.dataset.formId]);
}));


window.onload = (event) => {
  setTimeout(function(){
    let reviewbtn = document.querySelector('.spr-summary-actions-newreview');
    if(reviewbtn){
      reviewbtn.addEventListener('click', (event) => {
        //console.log('reviewbtn click');
        document.querySelector('.spr-form').scrollIntoView({behavior: 'smooth'});
      });
    }
  }, 2000);//wait 2 seconds
};

// Section Media Gallery Meta Auto-play
document.addEventListener('DOMContentLoaded', function() {
  initImageGalleryVideos();
});

function initImageGalleryVideos() {
  const videos = document.querySelectorAll('.image-gallery__item-video');
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isSafariIOS = isSafari && isIOS;
  
  let scrollTimer;
  let isScrolling = false;
  
  videos.forEach(video => {
    
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.autoplay = true;
    video.defaultMuted = true;
    video.preload = 'auto';
    
    
    if (isSafariIOS) {
      video.setAttribute('webkit-playsinline', 'true');
      video.setAttribute('playsinline', 'true');
      video.style.webkitTransform = 'translateZ(0)';
      video.style.transform = 'translateZ(0)';
      video.style.willChange = 'transform';
    }
    
    
    video.addEventListener('pause', function(e) {
      if (!isScrolling) {
        e.preventDefault();
        setTimeout(() => {
          this.play().catch(err => console.log('Force play after pause:', err));
        }, 10);
      }
    });
    
    
    video.addEventListener('suspend', function(e) {
      if (isSafariIOS) {
        setTimeout(() => {
          this.play().catch(err => console.log('Resume after suspend:', err));
        }, 100);
      }
    });
    
    video.load();
    
    function forcePlay() {
      if (video.readyState >= 2 && !isScrolling) {
        video.play().catch(error => {
          console.log('Gallery video autoplay attempt:', error);
        });
      }
    }
    
    forcePlay();
    
    video.addEventListener('loadeddata', forcePlay);
    video.addEventListener('canplay', forcePlay);
    video.addEventListener('loadedmetadata', forcePlay);
    
    
    function handleFirstInteraction() {
      video.play().catch(e => console.log('Play after interaction:', e));
      document.removeEventListener('click', handleFirstInteraction);
      document.removeEventListener('touchstart', handleFirstInteraction);
      document.removeEventListener('touchend', handleFirstInteraction);
    }
    
    document.addEventListener('click', handleFirstInteraction, { once: true });
    document.addEventListener('touchstart', handleFirstInteraction, { once: true });
    document.addEventListener('touchend', handleFirstInteraction, { once: true });
    
    
    const checkInterval = isSafariIOS ? 500 : 1000;
    setInterval(() => {
      if (video.paused && video.readyState >= 2 && !isScrolling) {
        video.play().catch(e => console.log('Periodic play check:', e));
      }
    }, checkInterval);
    
    const container = video.closest('.image-gallery__video-container');
    if (container) {
      container.addEventListener('mouseenter', () => {
        if (!isScrolling) {
          video.play().catch(e => console.log('Play on hover:', e));
        }
      });
    }
  });
  
  
  if (isSafariIOS) {
    let scrollEndTimer;
    
    function handleScrollStart() {
      isScrolling = true;
      clearTimeout(scrollEndTimer);
    }
    
    function handleScrollEnd() {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(() => {
        isScrolling = false;
        
        videos.forEach(video => {
          if (video.paused && video.readyState >= 2) {
            video.play().catch(e => console.log('Resume after scroll:', e));
          }
        });
      }, 150);
    }
    
    document.addEventListener('scroll', handleScrollStart, { passive: true });
    document.addEventListener('scroll', handleScrollEnd, { passive: true });
    document.addEventListener('touchstart', handleScrollStart, { passive: true });
    document.addEventListener('touchmove', handleScrollStart, { passive: true });
    document.addEventListener('touchend', handleScrollEnd, { passive: true });
    
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden && !isScrolling) {
        setTimeout(() => {
          videos.forEach(video => {
            if (video.paused && video.readyState >= 2) {
              video.play().catch(e => console.log('Resume after visibility change:', e));
            }
          });
        }, 200);
      }
    });
  }
  
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target.querySelector('.image-gallery__item-video');
        if (video) {
          if (entry.isIntersecting && !isScrolling) {
            video.play().catch(e => console.log('Play on intersection:', e));
          }
        }
      });
    }, {
      threshold: 0.3,
      rootMargin: '50px'
    });
    
    videos.forEach(video => {
      const container = video.closest('.image-gallery__item');
      if (container) {
        observer.observe(container);
      }
    });
  }
}
